import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dft137cxox: FaireBrandEntity = {
  token: "b_dft137cxox",
  type: "brand",
  name: "INK + ALLOY",
  avatarUrl:
    "https://cdn.faire.com/fastly/22d6beb778e85ca6f2d1746e6e463b394030044413bafa41b7b16aceb4b7cb8b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2d479019bb47b5a31ef5c1bcd23b7d8064d2c3cbf289a621df5c2010c52ee756.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/22d6beb778e85ca6f2d1746e6e463b394030044413bafa41b7b16aceb4b7cb8b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2d479019bb47b5a31ef5c1bcd23b7d8064d2c3cbf289a621df5c2010c52ee756.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 72,
  isTopShop: true,
  isInsider: true,
  description:
    "INK+ALLOY is the brand that makes your heart dance, your spirit sing, and your soul soar! Modern, inspiring, and effortlessly cool, INK+ALLOY celebrates the spirit of womanhood, the warmth of community, and the courage to be creative and bold. Our unique, handcrafted pieces, popping with a kaleidoscope of colors, evoke sheer joy and a whimsical sense of wonder and exploration. Our bright and breezy disposition is the perfect marriage between feeling good and doing good. INK+ALLOY is like wearing a big, colorful hug that gives you the warm + fuzzies all day, every day… you just can’t help but smile!\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:11.776Z",
    importedBy: "entity-db-cli",
  },
};
